(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('lastSync', LastSync);

  LastSync.$inject = [
    'SynchronizationService',
    '$rootScope'
  ];

  function LastSync(SynchronizationService, $rootScope) {
    return {
      restrict: 'AE',
      scope: {
        model: '@'
      },
      templateUrl: 'views/directives/last_sync.html',
      link: (scope) => {
        $rootScope.initialize.then(() => {
          scope.$watch('model', function() {
            scope.lastSync = null;
            if (scope.model) {
              SynchronizationService.last_sync(scope.model).then((result) => {
                scope.lastSync = result.data.last_sync;
              });
            }
          });
        });
      }
    };
  }
}());
